export default {
  locale: 'en-US',
  filter: {
    all: 'All',
    filter: 'Filter',
    reset: 'Reset',
    placeholder: 'Please input keyword'
  },
  editableTable: {
    options: 'Options',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    input: 'Please Input',
    addText: 'Add Content',
    deleteConfirm: 'Do you want to delete the current line?'
  },
  table: {
    // tslint:disable-next-line: no-invalid-template-strings
    total: '${count} items in total'
  },
  icon: {
    common: 'Universal',
    edit: 'Edit',
    suggest: 'Suggest',
    direction: 'Direction',
    data: 'Data',
    file: 'File',
    chart: 'Graphic',
    robot: 'Robot',
    ai: 'AI',
    logo: 'Logos'
  },
  tagSelect: {
    cancel: 'Cancel',
    confirm: 'Confirm',
    createNewTag: 'Create new tag'
  }
};
